var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMother(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15 28",
    style: {
      enableBackground: "new 0 0 15 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#424242;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.3,15l-2.8-8.1c-0.2-0.5-0.7-0.8-1.2-0.8h-6c-0.5,0-1,0.3-1.2,0.8L0.2,15c-0.2,0.6,0.1,1.3,0.6,1.5 c0.2,0.1,0.3,0.1,0.5,0.1c0.5,0,1-0.3,1.1-0.8l1.4-4v0.8L2,18.8c0,0.4,0.1,0.7,0.5,0.9c0.1,0.1,0.3,0.1,0.4,0.1h0.9v6.5 c0,0.8,0.6,1.4,1.4,1.5c0.8,0,1.5-0.6,1.5-1.4v-6c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5v6c0,0.8,0.6,1.4,1.4,1.5 c0.8,0,1.5-0.6,1.5-1.4v-6.5h0.9c0.1,0,0.3,0,0.4-0.1c0.3-0.2,0.5-0.5,0.5-0.9l-1.8-6.1v-0.8l1.4,4c0.2,0.5,0.6,0.8,1.1,0.8 c0.2,0,0.3,0,0.5-0.1C14.2,16.3,14.5,15.6,14.3,15z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.2,0c1.4,0,2.6,1.2,2.6,2.6S8.7,5.2,7.2,5.2S4.6,4.1,4.6,2.6S5.8,0,7.2,0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMother);
export default __webpack_public_path__ + "static/media/mother.2f236c36edbfea2920d95ca248e88c42.svg";
export { ForwardRef as ReactComponent };